import { TableSortEvent } from '../components/table.types';

const compare = (a: number | string, b: number | string, isAsc: boolean) =>
  (a < b ? -1 : 1) * (isAsc ? 1 : -1);

/**
 * Função auxiliar para ordenação dos dados das colunas da tabela
 *
 * @param dataSource array contendo os dados para ordenação
 *
 * @param event evento de ordenação contendo nome da coluna e direção
 *
 * @category Sort
 *
 * @example
 * ```ts
 * import { sortData } from '@ids/tools';
 *
 * myDataSource = sortData(myDataSource, event);
 * ```
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sortData = (dataSource: any[], event: TableSortEvent): any[] => {
  const sortedArray = dataSource
    .slice()
    .sort((a, b) => compare(a[event.name], b[event.name], event.direction === 'asc'));

  return sortedArray;
};
